import React, { useRef, useEffect } from 'react';

const LessonTitleInput = React.memo(({ value, onChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const stopProp = (e) => {
      if (e.target === input || input.contains(e.target)) {
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', stopProp, true);
    document.addEventListener('keypress', stopProp, true);
    document.addEventListener('keyup', stopProp, true);
    document.addEventListener('input', stopProp, true);

    return () => {
      document.removeEventListener('keydown', stopProp, true);
      document.removeEventListener('keypress', stopProp, true);
      document.removeEventListener('keyup', stopProp, true);
      document.removeEventListener('input', stopProp, true);
    };
  }, []);

  return (
    <input
      ref={inputRef}
      className="lesson-title-input"
      placeholder="Lesson Title"
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      onBlur={e => onChange(e.target.value || '')}
    />
  );
});

export default LessonTitleInput;
